import React from 'react'
import { NavLink } from 'react-router-dom'
import './style.css'

const Navbar = () => {
    return (
        <>
            <ul className="text-center">
                <li><NavLink to="/">Home</NavLink></li>
                {/* <li><NavLink to="/random">Random</NavLink></li> */}
                <li><NavLink to="/fav">My Fav</NavLink></li>
            </ul>
        </>
    )
}


export default Navbar